/**
 * VideoView view component.
 * @module components/theme/View/VideoView
 */
import React from 'react';
import cx from 'classnames';
import config from '@plone/volto/registry';
import { defineMessages, useIntl } from 'react-intl';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';

/**
 * VideoView view component class.
 * @function VideoView
 * @params {object} content object.
 * @returns {string} Markup of the view.
 */

const messages = defineMessages({
  transcript_label: {
    id: 'transcript_label',
    defaultMessage: 'Trascrizione',
  },
});

const VideoView = ({ content }) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';
  return (
    <Container>
      {content.title && (
        <h1 className="documentFirstHeading">{content.title}</h1>
      )}
      {/* Embedd video */}
      {content?.video_url ? (
        <div className="block video">
          <VideoPlayer data={{ url: content.video_url }} />
        </div>
      ) : content?.video_file ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          className="mb-4"
          controls
          width={content?.width ?? 560}
          height={content?.height ?? 315}
        >
          <source
            src={content.video_file.download}
            type={content.video_file['content-type']}
          />
        </video>
      ) : (
        <></>
      )}

      {/* Transcript */}
      {content?.transcript?.data &&
        content?.transcript?.data !== '<p><br></p>' && (
          <div className="mb-2">
            <p className="mb-0">
              <strong>{intl.formatMessage(messages.transcript_label)}</strong>
            </p>
            <span
              dangerouslySetInnerHTML={{ __html: content.transcript.data }}
            ></span>
          </div>
        )}
    </Container>
  );
};

export default VideoView;
